<template>
  <div>
    <template v-if="isIndexPage">
      <div
        :class="[
          'mb-20',
          {
            'mb-sm-30 mb-lg-40': !deviceType.isMobile,
          },
        ]"
      >
        <page-title
          :title="$t('components.sub.navigation.about-us')"
          :bordered="true"
          :back-button="{ url: 'profile', hiddenAfterSizes: 'sm' }"
        />
      </div>
      <div
        :class="[
          'px-20 mb-20',
          {
            'px-md-30 mb-sm-30 mb-lg-40': !deviceType.isMobile,
          },
        ]"
      >
        <div class="new-container mx-auto">
          <station :list="aboutUsMenu" />
        </div>
      </div>
    </template>
    <template v-else>
      <div>
        <nuxt-child />
      </div>
      <div class="tw-mt-5 md:tw-mt-7.5 lg:tw-mt-10 tw-mb-5 md:tw-mb-7.5 lg:tw-mb-10">
        <GetInTouch />
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    components: {
      PageTitle: () => import('~/components/shared/page-title.vue'),
      Station: () => import('~/components/shared/station.vue'),
      GetInTouch: () => import('~/components/about-us/media-center/get-in-touch.vue'),
    },

    async asyncData({ store }) {
      if (store.getters['aboutAiralo/get_get_in_touch_email_address']?.length === 0) {
        await store.dispatch('aboutAiralo/fetch_get_in_touch_email_address')
      }
    },

    watchParams: true,

    data() {
      return {
        aboutUsMenu: [
          {
            key: 'components.main.navigation.about.us.about-airalo',
            route: '/about-us/about-airalo',
            group: 'first',
          },
          {
            key: 'components.main.navigation.about.us.impact',
            route: '/about-us/impact',
            group: 'first',
          },
          {
            key: 'components.sub.navigation.founders',
            route: '/about-us/founders',
            group: 'first',
          },
          {
            key: 'components.footer.about.us.newsroom',
            route: '/about-us/newsroom',
            group: 'first',
          },
          {
            key: 'components.footer.about.us.media-center',
            route: '/about-us/media-center',
            group: 'first',
          },
        ],
      }
    },

    computed: {
      deviceType() {
        return this.$store.getters.get_device_types
      },
      routeBaseName() {
        return this.getRouteBaseName() ? this.getRouteBaseName() : 'about-us'
      },
      isIndexPage() {
        return this.routeBaseName === 'about-us' || this.routeBaseName === 'about-us-index'
      },
    },

    head() {
      return {
        title: this.$te('seo.about.us.title') ? this.$t('seo.about.us.title') : this.$t('seo.homepage.title'),
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.$t('seo.about.us.description'),
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: this.$t('seo.about.us.keywords'),
          },
          {
            property: 'og:title',
            content: this.$t('seo.about.us.title'),
          },
          {
            property: 'og:description',
            content: this.$t('seo.about.us.description'),
          },
        ],
      }
    },

    scrollToTop: true,
  }
</script>
